export const API_ENDPOINTS = {
  // BASE: process.env.REACT_APP_BASE_URL,
  uploadService: 'https://ufs.suplift.com',
  // uploadService: 'http://localhost:8080',
  experiences: {
    all: '/experiences',
    featured: '/experiences/featured',
    vibe: "/experiences/vibe",
    status: '/experiences/status',
    wanted: '/experiences/asked',
    allLite: '/experiences/autocomplete',
    addOrEditExp: (id?: string) => `/experiences${id ? `/${id}` : ''}`,
  },

  balance: '/accounts/totalbalance',
  cheering: '/balloons',
  booking: {
    all: '/transactions/list',
    refund: '/transactions',
    logs: '/bookings',
  },
  sessions: {
    all: '/sessions',
    default: 'sessions/default',
    sessionLearners: (expId: string, sessionId: string) =>
      `/experiences/${expId}/sessions/${sessionId}/learners`,
    sessionLearnersLogs: (sessionId: string) =>
      `/logs/admin/sessions/learners?id=${sessionId}`,
    removeLearner: (expId: string, sessionId: string, learnerId: string) =>
      `/experiences/${expId}/sessions/${sessionId}/cancelreserve/${learnerId}`,
    putAttendees: (expId: string, sessionId: string) =>
      `/experiences/${expId}/sessions/${sessionId}/attendees`,
  },
  coaches: {
    all: '/accounts',
    allLite: 'accounts/coaches',
    allList:
      'accounts?role=coach&page=0&isEnabled=true&limit=25&sortBy=unpaid_session',
    balance: (id: string) => `/accounts/${id}/balance`,
    logs: (coachId: string) => `/logs/admin/coach/sessions/paid?id=${coachId}`,
  },
  learners: {
    all: `/accounts?role=learner`,
    allLite: `/accounts/learners/phones`,
    byId: `/accounts`,
    logs: '/learners',
    addLearnerToSession: (expId: string, sessionId: string) =>
      `/experiences/${expId}/sessions/${sessionId}/reserve`,
  },
  discountCodes: {
    all: '/discounts',
  },
  giftCards: {
    all: '/gift-cards',
    booking: '/gift-cards-transactions',
    b2b: '/gift-cards-b2b',
    allLite: '/all-gift-cards',
    transaction: '/admin/issue-gift-card',
  },
  payment: '/moyasar/unidentified-payment/transaction',
  notifications: '/notifications',
  campaigns: '/compaigns/all',
  languages: '/languages',
  nationalities: '/nationalities',
  hobbies: '/hobbies',
  hobbiesForExperience: '/hobbies/experiences',
  logs: '/logs/admin',
  regions: '/regions',
  countries: '/countries?lang=en',
  login: '/login',
  paymentCategories: '/payment-categories',
  uploadImage: '/upload-experience-image',
  reviews: 'reviews',
  translation: `https://translation.googleapis.com/language/translate/v2?key=${process.env.REACT_APP_TRANSLATION_KEY}`,
  banners: {
    all: '/adbanners',
    sort: '/adbanners/update/ordering',
  },
  collection: {
    all: '/collections',
    byId: (id: string) => `/collections/${id}`,
    changeStatus: (id: string) => `/collections/${id}/deactivate`,
    createOrUpdate: (id?: string) => `/collections${id ? `/${id}` : ''}`,
    sort: '/collections/update/ordering',
  },
  approval: {
    all: '/approvals',
    getApprovalById: (approvalId: string) => `/approvals/${approvalId}`,
    changeApprovalStatus: (id: string) => `/approvals/coach/status/${id}`,
  },
  gigs: {
    list: '/gigs',
    liteList: '/all-gigs',
    applicationsList: `/gigs-applications`,
    gigRelatedApplicationsList: (id: string) => `/gigs/${id}/applications`,
    changeStatus: (gigId: string) => `/gigs/${gigId}/deactivate`,
    priceTypes: '/gigs/price-types',
    createGig: '/gigs',
    updateGig: (gigId: string) => `/gigs/${gigId}`,
    byId: (gigId: string) => `/gigs/${gigId}`,
    changeApplicationStatus: (id: string) => `gigs-applications/${id}/status`,
    segmentedCoaches: '/gigs/get-segmented-coaches',
    sendGigNotification: (gigId: string) => `gigs/${gigId}/segmented/notify`,
    notificationsHistoryList: '/all-gigs-notifications',
    searchOnSegmentedCoachByNotificationId: (notificationId: string) =>
      `/gigs/notification/${notificationId}/search`,
  },
  accountManager: '/accountmanagers',
  forceUpdate: '/force-update',
} as const;
